import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import AmendDeviceProvider from "./baseProviders/amendDeviceProvider"
import useGetTTRDeviceFormDataFromApiResponse from "../../../../hooks/useGetTTRDeviceFormDataFromApiResponse"
import useStartNewAmendment from "../../../../services/middleware/hooks/devices/ttr/useStartNewAmendment"

interface IAmendDeviceFormUrlParams {
    deviceRef: string
}

interface INewAmendmentProviderProps {
    children: ReactNode
}

const NewAmendmentProvider = ({
    children,
}: INewAmendmentProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof IAmendDeviceFormUrlParams
    >() as IAmendDeviceFormUrlParams

    const {
        data,
        isLoading,
        isValidating,
        error: newAmendmentError,
    } = useStartNewAmendment(urlDeviceRef)

    const { formData, setFormData } = useGetTTRDeviceFormDataFromApiResponse(
        isLoading,
        isValidating,
        newAmendmentError,
        data
    )

    const attachmentUUID = data?.AttachmentUUID

    return (
        <AmendDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={newAmendmentError}
            deviceId={data?.DeviceID}
            deviceRef={data?.DeviceRef}
            attachmentUUID={attachmentUUID}
        >
            {children}
        </AmendDeviceProvider>
    )
}

export default NewAmendmentProvider
